import React, {useState, useEffect, useRef} from "react";
import axios from 'axios';
import { Navigate, useParams } from "react-router-dom";
import Wrapper from "../../components/Wrapper";
import InnerNav from "../../components/InnerNav";
import { FiSave } from "react-icons/fi";
 

const DaysaleEdit = ()=>{
     const [date, setDate ] = useState('');
     const [amount, setAmount ] = useState('');
     const [trxCode, setTrxCode ] = useState('');
     const [stationId, setStationId ] = useState('');
     const [msisdn, setMsisdn ] = useState('');
     const [source, setSource ] = useState('');
     const [tillNo, setTillNo ] = useState('');
     const [trxTime, setTrxTime ] = useState('');
     const [payMethod, setPayMethod ] = useState('');
     const [attendantId, setAttendantId ] = useState('');
     const [timeIn, setTimeIn ] = useState('');
    const [redirect, setRedirect] = useState(false);
    const ref = useRef<HTMLInputElement>(null);

    let {id} = useParams();
    useEffect(() =>{
        (
            async () => {
                 const {data} = await axios.get(`daysale/${id}`);
                 setDate(data.date);
                 setAmount(data.amount);
                 setTrxCode(data.trx_code);
                 setStationId(data.station_id);
                 setMsisdn(data.msisdn);
                 setSource(data.source);
                 setTillNo(data.till_no);
                 setTrxTime(data.trx_time);
                 setPayMethod(data.pay_method);
                 setAttendantId(data.attendant_id);
                 setTimeIn(data.time_in);
             }
             )();
        },[id]);
        const submit = async (e)=>{
            e.preventDefault();
            const {data} = await axios.put(`daysale/${id}`, {
            date,
            amount,
            trxCode,
            stationId,
            msisdn,
            source,
            tillNo,
            trxTime,
            payMethod,
            attendantId,
            timeIn,
        });
        console.log(data);
        setRedirect(true);
    };
   
    if(redirect){
         return <Navigate to={'/daysale'} />
    }
    return (
        <Wrapper pageTitle={'Edit Daysale'}>
            <InnerNav createLink={'/daysaleCreate'} listLink={'/daysale'} />
             <form onSubmit={submit}>
                <div className="px-4 py-3 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800" >
                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Date </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Date" value={date}
                        onChange = {e => setDate(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Amount </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Amount" value={amount}
                        onChange = {e => setAmount(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">TrxCode </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="TrxCode" value={trxCode}
                        onChange = {e => setTrxCode(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">StationId </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="StationId" value={stationId}
                        onChange = {e => setStationId(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Msisdn </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Msisdn" value={msisdn}
                        onChange = {e => setMsisdn(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">Source </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="Source" value={source}
                        onChange = {e => setSource(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">TillNo </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="TillNo" value={tillNo}
                        onChange = {e => setTillNo(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">TrxTime </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="TrxTime" value={trxTime}
                        onChange = {e => setTrxTime(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">PayMethod </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="PayMethod" value={payMethod}
                        onChange = {e => setPayMethod(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">AttendantId </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="AttendantId" value={attendantId}
                        onChange = {e => setAttendantId(e.target.value)} />
                    </label>

                    <label className="block text-sm">
                        <span className="text-gray-700 dark:text-gray-400">TimeIn </span>
                        <input
                        className="block w-full p-2 border mt-1 text-sm border-gray-300 rounded-md h-10 focus:border-purple-400 focus:outline-none focus:shadow-outline-purple dark:text-gray-300 form-input "
                        placeholder="TimeIn" value={timeIn}
                        onChange = {e => setTimeIn(e.target.value)} />
                    </label>

                     <div className="flex mt-6 text-sm">
                        <label className="flex items-center dark:text-gray-400">
                         <button className="flex items-center justify-between px-4 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg active:bg-white hover:bg-blue-400 focus:outline-none focus:shadow-outline-purple"
                         onClick={submit}
                         > <FiSave /> <span className="ml-3">Save</span> </button>
                         </label>
                     </div>
                 </div>
             </form>
         </Wrapper>
     );
};
export default DaysaleEdit;